import apiService from './api';

/**
 * Project Type Service
 * Handles operations related to project types
 */
class ProjectTypeService {
  /**
   * Get all project types
   * @returns {Promise} Promise with project types data
   */
  async getProjectTypes() {
    try {
      const response = await apiService.get('/project-types');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching project types:', error);
      throw error;
    }
  }

  /**
   * Get project type by ID
   * @param {string} id - Project type ID
   * @returns {Promise} Promise with project type data
   */
  async getProjectType(id) {
    try {
      const response = await apiService.get(`/project-types/${id}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching project type with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Create a new project type (admin only)
   * @param {Object} projectTypeData - Project type data
   * @returns {Promise} Promise with created project type
   */
  async createProjectType(projectTypeData) {
    try {
      const response = await apiService.post('/project-types', projectTypeData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating project type:', error);
      throw error;
    }
  }

  /**
   * Update a project type (admin only)
   * @param {string} id - Project type ID
   * @param {Object} projectTypeData - Updated project type data
   * @returns {Promise} Promise with updated project type
   */
  async updateProjectType(id, projectTypeData) {
    try {
      const response = await apiService.put(`/project-types/${id}`, projectTypeData);
      return response.data.data;
    } catch (error) {
      console.error(`Error updating project type with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Delete a project type (admin only)
   * @param {string} id - Project type ID to delete
   * @returns {Promise} Promise with operation result
   */
  async deleteProjectType(id) {
    try {
      const response = await apiService.delete(`/project-types/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting project type with ID ${id}:`, error);
      throw error;
    }
  }
}

export default new ProjectTypeService();